// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.footer_disclaimer[data-v-012b0320] {
  font-size: 9px;
  opacity: 0.7;
}
#chat-widget[data-v-012b0320] {
  color: #000;
}
.cursor-pointer[data-v-012b0320] {
  cursor: pointer;
}
.main-menu-icon[data-v-012b0320] {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 1px;
  max-width: 12px;
  cursor: pointer;
  font-size: 22px;
}
#chat-widget[data-v-012b0320] ul.list-unstyled.service__types__list {
  margin-bottom: 0 !important;
}
#chat-widget[data-v-012b0320] .service__types__list__item:last-child .service__chips__btn {
  margin-bottom: 3px !important;
}
#chat-widget[data-v-012b0320] .service_offers .service__chips__btn {
  margin-bottom: 0 !important;
}
#chat-widget[data-v-012b0320] #chat__bodyview .df_message .primaryicon-right-arrow {
  width: 16px;
  height: 33px;
  border-radius: 3px 0px 0px 3px;
  margin: 0;
  padding: 5px !important;
  font-size: 10px;
  z-index: 99;
  right: 0 !important;
  position: absolute;
}
#chat-widget[data-v-012b0320] #chat__bodyview .df_message .primaryicon-left-arrow {
  width: 16px;
  height: 33px;
  border-radius: 0px 3px 3px 0;
  margin: 0;
  padding: 5px;
  font-size: 10px;
  z-index: 99;
  left: 0 !important;
  position: absolute;
}
#chat-widget[data-v-012b0320] .v-slick-slider {
  position: inherit;
}
.chat__footer__icon span[data-v-012b0320] {
  line-height: 0;
}
span.primaryicon-ellipsis-vertical1[data-v-012b0320] {
  width: 4px;
  height: 4px;
  display: block;
  background: #000;
  border-radius: 50%;
  box-sizing: border-box;
  letter-spacing: 0;
}
.send-icon[data-v-012b0320] {
  cursor: pointer;
  font-size: 30px;
  padding: 8px;
  transform: rotate(44deg);
  color: red;
  margin-right: 10px;
}
#chat-footer[data-v-012b0320] {
  border-top: 1px solid #ccc;
}
.waiting-message[data-v-012b0320] {
  font-style: italic;
}
.chat-text-box[data-v-012b0320] {
  box-shadow: 0 0 5pt 0.5pt #d3d3d3;
}
.chat-icon[data-v-012b0320] {
  font-size: 25px;
}
textarea[data-v-012b0320]:focus,
input[data-v-012b0320]:focus {
  outline: none;
}
.df-button[data-v-012b0320] {
  background-color: yellowgreen;
}
body[data-v-012b0320] {
  background: #eee;
}
.chat-list[data-v-012b0320] {
  padding: 0;
  font-size: 1.1rem;
}
.chat-list .chat-img[data-v-012b0320] {
  float: left;
  width: 48px;
}
.chat-list .chat-img img[data-v-012b0320] {
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  width: 100%;
}
.chat-list .chat-message[data-v-012b0320] {
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  background: #5a99ee;
  display: inline-block;
  padding: 10px 20px;
  position: relative;
}
.chat-list .chat-message[data-v-012b0320]:before {
  content: "";
  position: absolute;
  top: 15px;
  width: 0;
  height: 0;
}
.chat-list .chat-message h5[data-v-012b0320] {
  margin: 0 0 5px 0;
  font-weight: 900;
  line-height: 100%;
  font-size: 1.2rem;
}
.chat-list .chat-message p[data-v-012b0320] {
  line-height: 18px;
  margin: 0;
  padding: 0;
}
.chat-list .chat-body[data-v-012b0320] {
  margin-left: 20px;
  float: left;
  width: 70%;
}
.chat-list .in .chat-message[data-v-012b0320]:before {
  left: -12px;
  border-bottom: 20px solid transparent;
  border-right: 20px solid #5a99ee;
}
.chat-list .out .chat-img[data-v-012b0320] {
  float: right;
}
.chat-list .out .chat-body[data-v-012b0320] {
  float: right;
  margin-right: 20px;
  text-align: right;
}
.chat-list .out .chat-message[data-v-012b0320] {
  background: #fc6d4c;
}
.chat-list .out .chat-message[data-v-012b0320]:before {
  right: -12px;
  border-bottom: 20px solid transparent;
  border-left: 20px solid #fc6d4c;
}
.card .card-header[data-v-012b0320]:first-child {
  -webkit-border-radius: 0.3rem 0.3rem 0 0;
  -moz-border-radius: 0.3rem 0.3rem 0 0;
  border-radius: 0.3rem 0.3rem 0 0;
}
.card .card-header[data-v-012b0320] {
  background: #17202b;
  border: 0;
  font-size: 1.2rem;
  padding: 0.65rem 1rem;
  position: relative;
  font-weight: 900;
  color: #ffffff;
}
.content[data-v-012b0320] {
  margin-top: 40px;
}
.textwidget-close-icon[data-v-012b0320] {
  display: block !important;
  text-align: right;
  font-size: 24px;
  cursor: pointer;
  background-color: #f5f5f5;
}
.chat-image[data-v-012b0320] {
  position: absolute;
  width: 50px;
  top: -30px;
  right: 0px;
}
.nada-text-us-btn[data-v-012b0320] {
  cursor: pointer;
  font-size: 18px;
  color: #fff;
  text-align: center;
  padding: 12px 14px;
  letter-spacing: 2px;
  display: block;
  margin: 0px auto;
  min-width: 100px;
  background: #007cc3;
}
.nada-chat-con[data-v-012b0320] {
  padding: 18px;
  border-radius: 5px;
  border: 1px none #000000;
  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);
  color: #555555;
  z-index: 999999999;
  width: 18%;
  position: fixed;
  bottom: 10px;
  right: 5px;
  min-width: 310px;
  box-sizing: border-box;
}
.nada-child[data-v-012b0320] {
  box-sizing: border-box;
  margin: 12px 0;
  font-size: 14px;
}
.chat-con[data-v-012b0320] {
  position: fixed;
  bottom: 40px;
  z-index: 999;
}
.position-right-alignment[data-v-012b0320] {
  right: 0px;
}
.position-left-alignment[data-v-012b0320] {
  left: 0px;
}
.chat-con .circle-chat-con[data-v-012b0320] {
  background: transparent;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
}
.chat-con .circle-chat-con img[data-v-012b0320] {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.textwidgetbox[data-v-012b0320] {
  position: fixed;
  bottom: 0px;
  width: 25%;
  background: #fff;
  padding: 20px;
  padding-bottom: 0px;
  z-index: 999999999;
  box-shadow: 2px 2px 10px 3px #eeeeee;
}
.cls-3[data-v-012b0320] {
  fill: #fff;
}
@media (max-width: 800px) {
.textwidgetbox[data-v-012b0320] {
    width: 70%;
}
.send-btn-con .text-send-btn[data-v-012b0320] {
    margin: 5px 0;
}
}
@media (max-width: 600px) {
.chat-con[data-v-012b0320] {
    bottom: 25px;
    z-index: 1100 !important;
}
.chat-con.position-right-alignment[data-v-012b0320] {
    right: 4px;
}
.chat-con.position-left-alignment[data-v-012b0320] {
    left: 4px;
}
.nada-text-us-btn[data-v-012b0320] {
    cursor: pointer;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding: 14px;
    letter-spacing: 2px;
    display: block;
    margin: 0px auto;
    min-width: 150px;
    z-index: 3;
    width: 80%;
    position: fixed;
    bottom: 43px;
    right: 0;
    left: 0;
}
.nada-chat-con[data-v-012b0320] {
    width: 97%;
    min-width: unset;
    margin: 0 auto;
}
.textwidgetbox[data-v-012b0320] {
    width: 80%;
}
.chat-textarea-con[data-v-012b0320] {
    margin: 10px auto;
}
.textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left[data-v-012b0320] {
    width: 50%;
}
}
@media (min-width: 768px) and (max-width: 1366px) {
.chat-con[data-v-012b0320] {
    bottom: 89px;
}
}
#chat-widget .modal-content[data-v-012b0320] {
  box-shadow: 4px 0px 10px 0px #eeeeee;
  border-radius: 0;
  border-left: 1px solid #eee !important;
}
.chat__content.position-right-alignment[data-v-012b0320] {
  right: 0;
}
.chat__content.position-left-alignment[data-v-012b0320] {
  left: 0;
}
.chat__header[data-v-012b0320] {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  border-bottom: 1px solid #eee;
  border-top: 1px solid rgba(0, 0, 0, 0.095) !important;
  height: 5vh;
}
.chat__header__btn[data-v-012b0320] {
  padding: 0;
  background: none;
  border: 0;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  width: 25px;
}
.header__icon[data-v-012b0320] {
  font-size: 14px;
  font-weight: bold;
  color: #999;
}
.chat__header h5[data-v-012b0320] {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
}
.chat__body[data-v-012b0320] {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.chat__body__section[data-v-012b0320] {
  width: 100%;
  height: 75vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.chat__body__section2[data-v-012b0320] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
}
.chat__subSec[data-v-012b0320] {
  width: 100%;
  height: 65vh;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
}
#chatBodySec3 .chat__subSec[data-v-012b0320] {
  height: 75vh;
}
.chat__body__section2 .headTxt5[data-v-012b0320] {
  font-size: 13px;
  text-align: center;
  margin: 10px auto 10px;
  color: #000;
}
.chat__body__box[data-v-012b0320] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 30px 20px;
  cursor: pointer;
}
.chat__body__box[data-v-012b0320]:not(:last-child) {
  margin-bottom: 20px;
}
.chat__body__btn[data-v-012b0320] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
  margin-bottom: 5px;
  background: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  padding: 0;
}
.icon__cont__box img[data-v-012b0320] {
  height: 40px;
  margin-right: 9px;
}
.icon__cont[data-v-012b0320] {
  font-size: 12px;
}
#chatBodySec1 .chat__body__btn__title[data-v-012b0320] {
  font-size: 20px !important;
  font-weight: 900;
}
.chat__body__para[data-v-012b0320] {
  font-size: 9px;
  font-weight: 400;
  text-align: center;
  color: #999;
}
.chat__footer[data-v-012b0320] {
  width: 100%;
  height: 5vh;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0;
  position: relative;
  z-index: 9;
}
.txtInput[data-v-012b0320] {
  width: 100%;
  height: 5vh;
  background: #f5f5f5;
  border: 0;
  border-radius: 0;
  outline: none;
  text-align: left;
  padding: 5px 10px;
  font-size: 16px;
  color: #000;
}
.chat__footer__btn[data-v-012b0320] {
  width: 2vw;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border: 0;
  border-radius: 0;
  outline: none;
  cursor: pointer;
}
.chat__footer__icon[data-v-012b0320] {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 9;
}
.chat__conversation__block[data-v-012b0320] {
  width: 100%;
}
.chat__conversation__block div[data-v-012b0320]:nth-of-type(1) {
  padding: 0;
}
.chat__conversation__block div:nth-of-type(1) div[data-v-012b0320] {
  padding: 0;
}
.chat__conversation__block div[data-v-012b0320]:not(:first-child) {
  padding: 0;
}
.chat__conversation__block div:not(:first-child)>div[data-v-012b0320] {
  padding: 0;
}
.chips__btn[data-v-012b0320] {
  font-size: 12px;
  font-weight: 400;
  padding: 6px 12px;
  min-width: 56px;
  height: 32px;
}
#chat-widget .rounded-buttons.chips__btn[data-v-012b0320] {
  font-size: 12px !important;
  font-weight: 400 !important;
  padding: 6px 12px !important;
  min-width: 56px !important;
  height: 32px !important;
  text-transform: unset !important;
}
.chat_loader[data-v-012b0320] {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 24px;
  align-items: center;
  justify-content: center;
}
@-webkit-keyframes ball-pulse-sync-012b0320 {
20% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
40% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
60% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
80% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
}
}
@keyframes ball-pulse-sync-012b0320 {
20% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
40% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
60% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
80% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
}
}
.ball-pulse-sync>div[data-v-012b0320]:nth-child(1) {
  -webkit-animation: ball-pulse-sync-012b0320 1s -0.36s infinite ease-in-out;
  animation: ball-pulse-sync-012b0320 1s -0.36s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-012b0320]:nth-child(2) {
  -webkit-animation: ball-pulse-sync-012b0320 1s -0.27s infinite ease-in-out;
  animation: ball-pulse-sync-012b0320 1s -0.27s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-012b0320]:nth-child(3) {
  -webkit-animation: ball-pulse-sync-012b0320 1s -0.18s infinite ease-in-out;
  animation: ball-pulse-sync-012b0320 1s -0.18s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-012b0320]:nth-child(4) {
  -webkit-animation: ball-pulse-sync-012b0320 1s -0.09s infinite ease-in-out;
  animation: ball-pulse-sync-012b0320 1s -0.09s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-012b0320]:nth-child(5) {
  -webkit-animation: ball-pulse-sync-012b0320 1s 0s infinite ease-in-out;
  animation: ball-pulse-sync-012b0320 1s 0s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-012b0320] {
  width: 5px;
  height: 5px;
  border-radius: 100%;
  margin: 0px;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: inline-block;
}
@media all and (max-width: 576px) {
.chat__content[data-v-012b0320] {
    width: 80%;
}
.chat__footer__btn[data-v-012b0320] {
    width: 12vw;
}
}
@media all and (min-width: 577px) {
.chat__content[data-v-012b0320] {
    width: 80%;
}
.chat__footer__btn[data-v-012b0320] {
    width: 12vw;
}
}
@media all and (min-width: 768px) {
.chat__content[data-v-012b0320] {
    width: 50%;
}
.chat__footer__btn[data-v-012b0320] {
    width: 8vw;
}
}
@media all and (min-width: 992px) {
.chat__content[data-v-012b0320] {
    width: 30%;
}
.chat__footer__btn[data-v-012b0320] {
    width: 4vw;
}
}
@media all and (min-width: 1200px) {
.chat__content[data-v-012b0320] {
    width: 28%;
}
.chat__footer__btn[data-v-012b0320] {
    width: 3vw;
}
}
@media all and (min-width: 1400px) {
.chat__content[data-v-012b0320] {
    width: 24%;
}
}
@media all and (min-width: 1900px) {
.footer_disclaimer[data-v-012b0320] {
    font-size: 11px;
}
.header__icon.primaryicon-times[data-v-012b0320] {
    font-size: 11px !important;
    color: #d9d9d9;
}
.header__icon.primaryicon-longarrow-left[data-v-012b0320] {
    font-size: 14px !important;
    font-weight: bold;
}
.chat__body__box[data-v-012b0320] {
    padding: 50px 30px;
}
.chat__subSec[data-v-012b0320] {
    height: 65vh;
}
.chat__body__section[data-v-012b0320] {
    height: 75vh;
}
#chatBodySec3 .chat__subSec[data-v-012b0320] {
    height: 75vh;
}
.chat__footer[data-v-012b0320] {
    height: 6vh;
}
.chat__footer__icon[data-v-012b0320] {
    height: 6vh;
}
.chat__footer__icon svg[data-v-012b0320] {
    height: 21px !important;
    margin-bottom: 2px;
}
.py-lg-c-2[data-v-012b0320] {
    padding: 0.5rem 0 !important;
}
.py-lg-c-2 .ft-10[data-v-012b0320] {
    font-size: 11px !important;
}
.txtInput[data-v-012b0320] {
    height: 6vh;
    font-size: 16px;
}
.chat__footer__btn[data-v-012b0320] {
    width: 3vw;
    height: 6vh;
}
.chat__footer__btn i[data-v-012b0320] {
    font-size: 20px;
}
.chat__header h5[data-v-012b0320] {
    font-size: 16px;
}
.chat__body__section2 .headTxt5[data-v-012b0320] {
    font-size: 19px;
    font-weight: bold;
    margin-top: 20px;
}
.chat__body__para[data-v-012b0320] {
    font-size: 11px;
}
#chatBodySec1 .icon__cont[data-v-012b0320] {
    font-size: 20px;
}
#chatBodySec1 .chat__body__para[data-v-012b0320] {
    font-size: 14px;
}
.header__icon[data-v-012b0320] {
    font-size: 11px;
}
#chatBodySec1 .chat__body__btn__title[data-v-012b0320] {
    font-size: 40px !important;
    font-weight: 900;
}
.icon__cont__box img[data-v-012b0320] {
    height: 50px;
}
}
@media all and (min-width: 2500px) {
.footer_disclaimer[data-v-012b0320] {
    font-size: 11px;
}
.chat__body__box[data-v-012b0320] {
    padding: 70px 30px;
    min-height: 320px;
}
.chat__footer[data-v-012b0320] {
    height: 4vh;
}
.txtInput[data-v-012b0320] {
    height: 4vh;
    font-size: 20px;
}
.chat__footer__btn[data-v-012b0320] {
    width: 3vw;
    height: 4vh;
}
.chat__footer__btn i[data-v-012b0320] {
    font-size: 24px;
}
.chat__header h5[data-v-012b0320] {
    font-size: 20px;
}
.chat__body__section2 .headTxt5[data-v-012b0320] {
    font-size: 20px;
}
#chatBodySec1 .icon__cont__box[data-v-012b0320] {
    width: 48px;
    height: 48px;
    margin-right: 20px;
}
#chatBodySec1 .icon__cont[data-v-012b0320] {
    font-size: 20px;
}
#chatBodySec1 .chat__body__para[data-v-012b0320] {
    font-size: 20px;
}
.header__icon[data-v-012b0320] {
    font-size: 20px;
}
}
@media all and (min-width: 3800px) {
.footer_disclaimer[data-v-012b0320] {
    font-size: 11px;
}
.chat__body__box[data-v-012b0320] {
    padding: 50px 30px;
    min-height: 420px;
}
.chat__body__box[data-v-012b0320]:not(:last-child) {
    margin-bottom: 50px;
}
.chat__content[data-v-012b0320] {
    width: 22%;
}
.chat__header[data-v-012b0320] {
    padding: 5px 20px;
}
#chatBodySec3 .chat__subSec[data-v-012b0320] {
    height: 76vh;
}
.chat__footer[data-v-012b0320] {
    height: 4vh;
}
.txtInput[data-v-012b0320] {
    height: 4vh;
    font-size: 24px;
}
.chat__footer__btn[data-v-012b0320] {
    width: 3vw;
    height: 4vh;
}
.chat__footer__btn i[data-v-012b0320] {
    font-size: 28px;
}
.chat__header h5[data-v-012b0320] {
    font-size: 28px;
}
.chat__body__section2 .headTxt5[data-v-012b0320] {
    font-size: 32px;
    margin: 20px auto 30px;
}
.chat__body__para[data-v-012b0320] {
    font-size: 32px;
}
#chatBodySec1 .icon__cont__box[data-v-012b0320] {
    width: 82px;
    height: 82px;
    margin-right: 20px;
}
#chatBodySec1 .icon__cont[data-v-012b0320] {
    font-size: 36px;
}
#chatBodySec1 .chat__body__para[data-v-012b0320] {
    font-size: 28px;
}
.header__icon[data-v-012b0320] {
    font-size: 32px;
}
}
.text__conversation__block[data-v-012b0320] {
  width: 100%;
  height: auto;
}
.text__conversation__block[data-v-012b0320] .beforechannelsready {
  width: 100%;
  padding: 0 20px;
}
.text__conversation__block[data-v-012b0320] .back-button {
  visibility: hidden;
}
.text__conversation__block[data-v-012b0320] .channel-list {
  width: 100%;
  padding: 0 20px;
  margin: 0 0 20px 0;
}
.text__conversation__block[data-v-012b0320] .channel-form {
  width: 100%;
  height: auto;
  overflow: auto;
  padding: 0 20px;
}
.text__conversation__block[data-v-012b0320] .input__contA {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
}
.text__conversation__block[data-v-012b0320] .mobile-number-box .name-input {
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 12px;
}
.text__conversation__block[data-v-012b0320] .mobile-number-box .input__hold {
  margin: 0 0 10px 0;
}
.text__conversation__block[data-v-012b0320] .mobile-number-box .mobile-number {
  color: #999;
  margin: 5px 0;
  font-size: 11px;
}
.text__conversation__block[data-v-012b0320] .chat-textarea-con::before,
.text__conversation__block[data-v-012b0320] .chat-textarea-con::after {
  display: none;
}
.text__conversation__block[data-v-012b0320] .chat-textarea-con textarea {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
}
.text__conversation__block[data-v-012b0320] .sales-radio-con {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.text__conversation__block[data-v-012b0320] .sales-radio-con>div {
  float: left;
  width: 100%;
}
.text__conversation__block[data-v-012b0320] .sales-radio-con .custom-radio-btn .radio-text {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.text__conversation__block[data-v-012b0320] .sales-radio-con .custom-radio-btn .radio-text .custom-radio-btn-input {
  margin-right: 5px;
}
.text__conversation__block[data-v-012b0320] .sales-radio-con .custom-radio-btn .radio-text .custom-radio-btn-label {
  font-size: 10px;
}
.text__conversation__block[data-v-012b0320] .note-info-text {
  font-size: 13px;
}
.text__conversation__block[data-v-012b0320] .chat-textarea-con {
  width: 100%;
  margin: 20px auto;
  font-size: 12px;
}
.service__types[data-v-012b0320] em.primaryicon-left-arrow.slick-arrow {
  background: #007cc3 !important;
}
.service__types[data-v-012b0320] em.primaryicon-right-arrow.slick-arrow {
  background: #007cc3 !important;
}
.service__types[data-v-012b0320] em.primaryicon-left-arrow.slick-disabled,
.service__types[data-v-012b0320] em.primaryicon-right-arrow.slick-disabled {
  pointer-events: none;
  opacity: 0;
}
.chat__footer__icon .footer-menu svg[data-v-012b0320] {
  position: relative;
  bottom: 0px;
}
.chat__footer__icon .footer-menu[data-v-012b0320]:hover {
  cursor: pointer;
  background: #f5f5f5;
  transition: 0.5s;
}
.chat__footer__icon .footer-menu:hover svg[data-v-012b0320] {
  bottom: -2px;
  transition: 0.5s;
}
.chat__footer__icon img[data-v-012b0320] {
  height: 12px;
}
.footer-menu svg[data-v-012b0320] {
  height: 16px;
  fill: #b3b3b3;
}
.header__icon.primaryicon-times[data-v-012b0320] {
  font-size: 11px !important;
  color: #d9d9d9;
}
.header__icon.primaryicon-longarrow-left[data-v-012b0320] {
  color: #c7c7c7;
  font-size: 14px;
  font-weight: bold;
}
.chat__subSec[data-v-012b0320]::-webkit-scrollbar {
  width: 3px;
}
.chat__subSec[data-v-012b0320]::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}
#chat-widget.textwidgetbox[data-v-012b0320] {
  box-shadow: none !important;
}
.chat__footer.opacity-0[data-v-012b0320] {
  opacity: 0;
}
.chat-con.position-right-alignment[data-v-012b0320] {
  right: 10px;
}
.chat-con.position-left-alignment[data-v-012b0320] {
  left: 10px;
}
.chat_widget_footer_menu #MessageBox[data-v-012b0320]:active {
  font-size: 16px !important;
}
.txtInput[data-v-012b0320]::placeholder {
  color: #0000008c !important;
}
#chat-widget[data-v-012b0320] .service__types__list__item .service__chips__btn {
  font-weight: 400 !important;
  padding: 6px 12px !important;
  min-width: 56px;
  text-transform: unset !important;
  font-size: 12px !important;
}
#chat-widget[data-v-012b0320] .chat__subSec .service__chips__btn {
  font-weight: 400 !important;
  padding: 6px 12px !important;
  min-width: 56px;
  text-transform: unset !important;
  font-size: 12px !important;
}
#chat-widget[data-v-012b0320] .service_offers .service__chips__btn {
  margin-bottom: 0 !important;
  font-weight: 400 !important;
  padding: 6px 12px !important;
  min-width: 56px;
  text-transform: unset !important;
  font-size: 12px !important;
}
#chat-widget[data-v-012b0320] #Service_Types .service__chips__btn {
  font-size: 9px !important;
  font-weight: 400 !important;
  padding: 2px !important;
  min-width: 56px !important;
  color: #fff !important;
}
.header__icon.primaryicon-times[data-v-012b0320]:hover {
  background: #f3f3f3;
  transition: 0.5s ease-in-out;
  transform: rotate(360deg);
  display: block;
  color: #000;
  padding: 5px;
  box-sizing: content-box;
}
.header__icon.primaryicon-longarrow-left[data-v-012b0320]:hover {
  background: #f3f3f3;
  transition: 0.4s ease-in-out;
  padding: 6px 8px;
  color: #000;
  font-size: 10px !important;
  box-sizing: content-box;
}
.disableSignIn[data-v-012b0320] {
  pointer-events: none;
  opacity: 0.8;
  cursor: not-allowed;
}
.text_length_validation[data-v-012b0320] {
  text-align: center;
  background: #eb9c5c;
  color: #fff;
  font-size: 12px;
  padding: 3px;
  position: relative;
  z-index: 1;
}
.slide-up-enter-active[data-v-012b0320],
.slide-up-leave-active[data-v-012b0320] {
  transition: transform 0.5s;
  transform: translateY(0px);
}
.slide-up-enter[data-v-012b0320],
.slide-up-leave-to[data-v-012b0320] {
  transform: translateY(30px);
}
#chat-widget.textwidgetbox.is_tablet_device[data-v-012b0320] {
  width: 50% !important;
}
.scroll_bottom_indicator[data-v-012b0320] {
  position: absolute;
  right: 10px;
  bottom: 18%;
  width: 20px;
  height: 20px;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  background: #fff;
  border: 1px solid #d5cccc;
  cursor: pointer;
  border-radius: 50%;
  z-index: 1;
}
@media (min-width: 1900px) {
.scroll_bottom_indicator[data-v-012b0320] {
    width: 22px;
    height: 22px;
    font-size: 10px;
}
}
.scroll_bottom_indicator[data-v-012b0320]:hover {
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
}
.scroll_bottom_indicator.animated_bottom[data-v-012b0320] {
  display: flex;
  animation: animated_bottom-012b0320 2s;
  transition: 0.5s;
}
@keyframes animated_bottom-012b0320 {
0% {
    transform: translateY(60px);
}
100% {
    transform: translateY(0px);
}
}
.light-box-area[data-v-012b0320] {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 99;
}
.signInNavigationModalLoader[data-v-012b0320] {
  position: absolute;
  background: rgba(240, 242, 250, 0.768627451);
  height: 100%;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}
.signInNavigationModalLoader .c_border_r[data-v-012b0320] {
  border-radius: 11px;
}
.chat__footer__icon[data-v-012b0320]:has(.disableSignIn) {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/ChatWidget/ChatWidget.vue"],"names":[],"mappings":";AAiOA;EACE,cAAc;EACd,YAAY;AACd;AAEA;EACE,WAAW;AACb;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,iBAAiB;AACnB;AAIA;EACE,cAAc;AAChB;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,kBAAkB;AACpB;AAEA;EACE,0BAA0B;AAC5B;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,iCAAiC;AACnC;AAEA;EACE,eAAe;AACjB;AAEA;;EAEE,aAAa;AACf;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,WAAW;AACb;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;AACX;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,gCAAgC;AAClC;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;AACjC;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,gCAAgC;AAClC;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AAEA;EACE,UAAU;AACZ;AAEA;EACE,SAAS;AACX;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;AAEA;EACE,UAAU;AACZ;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,aAAa;AACf;AACF;AAEA;AACE;IACE,YAAY;IACZ,wBAAwB;AAC1B;AAEA;IACE,UAAU;AACZ;AAEA;IACE,SAAS;AACX;AAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,OAAO;AACT;AAEA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;AAChB;AAEA;IACE,UAAU;AACZ;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,YAAY;AACd;AACF;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,sCAAsC;AACxC;AAEA;EACE,QAAQ;AACV;AAEA;EACE,OAAO;AACT;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,qDAAqD;EACrD,WAAW;AACb;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;AAChB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,YAAY;AACd;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;AAEA;EACE,WAAW;AACb;AAEA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;AACZ;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,gCAAgC;AAClC;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;AACE;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,gCAAgC;IAChC,wBAAwB;AAC1B;AACF;AAEA;AACE;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,gCAAgC;IAChC,wBAAwB;AAC1B;AACF;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,sEAA6D;EAC7D,8DAAqD;AACvD;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;AACvB;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,WAAW;AACb;AACF;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,WAAW;AACb;AACF;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,0BAA0B;IAC1B,cAAc;AAChB;AAEA;IACE,0BAA0B;IAC1B,iBAAiB;AACnB;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,YAAY;AACd;AAEA;IACE,YAAY;AACd;AAEA;IACE,YAAY;AACd;AAEA;IACE,WAAW;AACb;AAEA;IACE,WAAW;AACb;AAEA;IACE,uBAAuB;IACvB,kBAAkB;AACpB;AAEA;IACE,4BAA4B;AAC9B;AAEA;IACE,0BAA0B;AAC5B;AAEA;IACE,WAAW;IACX,eAAe;AACjB;AAEA;IACE,UAAU;IACV,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AAClB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,0BAA0B;IAC1B,gBAAgB;AAClB;AAEA;IACE,YAAY;AACd;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,kBAAkB;IAClB,iBAAiB;AACnB;AAEA;IACE,WAAW;AACb;AAEA;IACE,WAAW;IACX,eAAe;AACjB;AAEA;IACE,UAAU;IACV,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;AACpB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,kBAAkB;IAClB,iBAAiB;AACnB;AAEA;IACE,mBAAmB;AACrB;AAEA;IACE,UAAU;AACZ;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,YAAY;AACd;AAEA;IACE,WAAW;AACb;AAEA;IACE,WAAW;IACX,eAAe;AACjB;AAEA;IACE,UAAU;IACV,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;IACf,sBAAsB;AACxB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;AACpB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,eAAe;AACjB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AAEA;;EAEE,aAAa;AACf;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AAEA;EACE,WAAW;EACX,WAAW;AACb;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AAEA;EACE,8BAA8B;AAChC;AAEA;EACE,8BAA8B;AAChC;AAEA;;EAEE,oBAAoB;EACpB,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,UAAU;AACZ;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,UAAU;AACZ;AAEA;EACE,WAAW;AACb;AAEA;EACE,UAAU;AACZ;AAEA;EACE,0BAA0B;AAC5B;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;EAChC,0BAA0B;AAC5B;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;EAChC,0BAA0B;AAC5B;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;EAChC,0BAA0B;AAC5B;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;AACzB;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AAEA;;EAEE,0BAA0B;EAC1B,0BAA0B;AAC5B;AAEA;;EAEE,2BAA2B;AAC7B;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AAEA;AACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;AACjB;AACF;AAEA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;AAEA;EACE,aAAa;EACb,sCAA6B;EAC7B,gBAAgB;AAClB;AAEA;AACE;IACE,2BAA2B;AAC7B;AAEA;IACE,0BAA0B;AAC5B;AACF;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;AACb;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["<template>\r\n  <div>\r\n    <div>\r\n      <div>\r\n        <div v-if=\"showtext && !showchat\" id=\"chat_button_enabled\" class=\"chat-con\" :class=\"chatAlignmentPosition()\">\r\n          <div class=\"chat-child\">\r\n            <div v-if=\"!ismobile && !isChatOpenInModal\"\r\n              class=\"d-flex justify-content-center align-items-center nada-text-us-btn _theme_font_bold font-weight-bold theme-bg-color rounded-corners btn-websites button-primary\"\r\n              :class=\"{ 'bgcolor-primary': !textUsButtonColor }\" :style=\"{\r\n                'background-color': textUsButtonColor,\r\n                color: textUsFontColor,\r\n                'border-color': borderColor,\r\n              }\" @click.prevent=\"openchatwidget($event)\">\r\n              {{ widgetName }}\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div v-if=\"showchat && !ismobile && !isChatOpenInModal\" id=\"chat_button_enabled\">\r\n          <chat-assistant @openAssistant=\"openAssistant($event)\" @openService=\"openService($event)\"\r\n            @tileNavigate=\"assistantParamsDataModal($event)\" @modalNavigate=\"modalNavigate($event)\"\r\n            @disableWebBackgroundBlur=\"disableWebBackgroundBlur($event)\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div v-if=\"showwidget\" id=\"chat-widget\" :class=\"[\r\n        chatAlignmentPosition(),\r\n        { textwidgetbox: !ismobile && !isChatOpenInModal },\r\n        { is_tablet_device: isTablet },\r\n      ]\" class=\"pt-0 px-0 pb-0\">\r\n        <div>\r\n          <div class=\"modal-content border-0\">\r\n            <div v-if=\"!isWorkingHoursEnable\" class=\"chat__header\">\r\n              <button v-if=\"showLandingLayout && !ismobile\" class=\"chat__header__btn\" @click=\"hidewidget()\">\r\n                <i title=\"Back\" class=\"header__icon primaryicon-longarrow-left\" style=\"cursor: pointer\"\r\n                  :style=\"{ color: themePrimaryColor }\" />\r\n              </button>\r\n\r\n              <button v-if=\"textUsButtonsNavigation\" id=\"textUsFormEnabled\" class=\"chat__header__btn\"\r\n                @click=\"textUsButtonsNavigationClose()\">\r\n                <i title=\"Back\" :style=\"{ color: themePrimaryColor }\" class=\"header__icon primaryicon-longarrow-left\" />\r\n              </button>\r\n              <template v-else>\r\n                <button v-if=\"showChatData\" class=\"chat__header__btn\"></button>\r\n                <button v-if=\"showTextData\" class=\"chat__header__btn\">\r\n                  <i v-if=\"isShowTextUsForm\" title=\"Back\" class=\"header__icon primaryicon-longarrow-left\"\r\n                    :style=\"{ color: themePrimaryColor }\" @click=\"closeTextUsForm()\" />\r\n                </button>\r\n              </template>\r\n\r\n              <h5>\r\n                <span class=\"d-flex align-items-center\"><assistant-icon v-if=\"widgetTitle === 'Assistant'\" :width=\"30\"\r\n                    :height=\"30\" class=\"mr-2\" />\r\n                  {{ widgetTitle }}</span>\r\n              </h5>\r\n              <button v-if=\"!ismobile\" title=\"Close\" class=\"chat__header__btn close-animation\" style=\"cursor: pointer\"\r\n                @click.prevent=\"hidewidget()\">\r\n                <i class=\"header__icon primaryicon-times\" :style=\"{ color: themePrimaryColor }\" />\r\n              </button>\r\n              <button v-if=\"ismobile\" title=\"Close\" class=\"chat__header__btn close-animation\" style=\"cursor: pointer\"\r\n                :style=\"{ color: themePrimaryColor }\" @click=\"$emit('close')\">\r\n                <i class=\"header__icon primaryicon-times\" />\r\n              </button>\r\n            </div>\r\n            <div v-if=\"isWorkingHoursEnable\" class=\"chat__header\">\r\n              <button class=\"chat__header__btn\" :style=\"{ color: themePrimaryColor }\" @click=\"\r\n                isWorkingHoursEnable = false;\r\n              scrollAndFocus();\r\n              \">\r\n                <i title=\"Back\" class=\"header__icon primaryicon-longarrow-left\" style=\"cursor: pointer\"\r\n                  :style=\"{ color: themePrimaryColor }\" />\r\n              </button>\r\n              <h5>\r\n                <span>{{ componentNavigationLabel }}</span>\r\n              </h5>\r\n              <button title=\"Close\" class=\"chat__header__btn close-animation\" style=\"cursor: pointer\" @click.prevent=\"\r\n                isWorkingHoursEnable = false;\r\n              scrollAndFocus();\r\n              \">\r\n                <i class=\"header__icon primaryicon-times\" :style=\"{ color: themePrimaryColor }\" />\r\n              </button>\r\n            </div>\r\n            <div id=\"chatbody\" class=\"chat__body\">\r\n              <div v-if=\"showChatData\" id=\"chatBodySec2\" class=\"chat__body__section2 position-relative\"\r\n                :class=\"{ 'position-relative': isEnableAssistantParamsDataModal }\">\r\n                <div v-if=\"!isWorkingHoursEnable\" id=\"chat__bodyview\" class=\"chat__subSec\"\r\n                  :style=\"{ height: chatWidgetLayoutHeight }\">\r\n                  <!-- flow indicator -->\r\n                  <tvm-flow-name-indicator v-if=\"processNameIndicator\" :flow-indicator=\"flowIndicator\"\r\n                    :process-name-indicator=\"processNameIndicator\" />\r\n                  <!-- end flow indicator -->\r\n                  <!-- flow indicator -->\r\n                  <!-- end flow indicator -->\r\n                  <div class=\"chat__conversation__block\">\r\n                    <div v-for=\"(item, index) in fullfillmenttextList\" :key=\"index\" :id=\"'tileHeight-' + index\">\r\n                      <user-text-response v-if=\"item.request?.UserResponse\" :userinput=\"item.request\"\r\n                        :requesttime=\"item.requestTime\" @reloadDisableChat=\"reloadDisableChat\" :index=\"index\" />\r\n\r\n                      <user-text-response v-else-if=\"item.request?.EventLabel\" :userinput=\"item.request\"\r\n                        :requesttime=\"item.requestTime\" @reloadDisableChat=\"reloadDisableChat\" :index=\"index\" />\r\n\r\n                      <tvm-full-fillment-text v-if=\"item && item.responseData\" :is-last-index=\"fullfillmenttextList.length\r\n                        ? fullfillmenttextList.length - 1 === index\r\n                        : false\r\n                        \" :full-fill-ment-text=\"item.fullfillmentText\" :request=\"item.request\"\r\n                        :response-data=\"item.responseData\" :response-time=\"item.responseTime\"\r\n                        :header-offset-height=\"headerOffsetHeight\" :index=\"index\" :user-input-text=\"userInput\"\r\n                        :selected-auto-completed-value=\"selectedAutoCompletedValue\"\r\n                        :chat-theme-settings=\"chatThemeSettings\" :is-waiting-for-response=\"isWaitingForResponse\"\r\n                        :item-data=\"item\" @tvm-suggestions=\"tvmSuggestions\" @TvmKbbOffSetValue=\"tvmKbbOffSetValue\"\r\n                        @show-text-us-form=\"showTextUsForm\" @mainMenu=\"mainMenu\"\r\n                        @show-text-us-other-form=\"showTextUsOtherForm\" @selectedInputAddress=\"selectedInputAddress\"\r\n                        @selectedInputYmmt=\"selectedInputYmmt\" @fullFillmentIndex=\"fullFillmentIndex\"\r\n                        @tvm-structured-suggestions=\"tvmSuggestions\" />\r\n                    </div>\r\n\r\n                    <tvm-pre-loader v-if=\"chatResponseDelayLoading || isLoader\" />\r\n\r\n                    <tvm-api-error-regenerate @showTextUsOtherForm=\"showTextUsOtherForm\"\r\n                      @mainMenu=\"startMainMenu($event)\" @hideTvmApiErrorRegenerate=\"hideTvmApiErrorRegenerate($event)\"\r\n                      v-if=\"isApiError && !isLoader\" :response=\"isApiError\" />\r\n\r\n                    <div :style=\"{\r\n                      height: isTileNavigate ? isTileNavigateHeight - 50 + 'px' : 'auto',\r\n                    }\" id=\"isTileNavigate\" v-if=\"fullfillmenttextList?.length\" />\r\n                  </div>\r\n\r\n                  <slide-out-panel v-if=\"!ismobile && !isTablet\" :header-offset-height=\"headerOffsetHeight\"\r\n                    :slide-out=\"slideOutData\" :flow-indicator=\"flowIndicator\"\r\n                    :disable-background-blur=\"disableBackgroundBlur\" />\r\n                </div>\r\n                <div v-if=\"isWorkingHoursEnable\" id=\"chat__bodyview\" class=\"w-100 px-3 pt-3 chat__subSec\"\r\n                  :style=\"{ height: chatWidgetLayoutHeight }\">\r\n                  <component :is=\"componentNavigation\" />\r\n                </div>\r\n                <tvm-loader-modal v-if=\"isSignInNavigationModal\" message=\"Logging you in. Please wait...\" />\r\n                <tvm-loader-modal v-if=\"isSignOut\" message=\"Logging you out. Please wait...\" />\r\n                <tvm-loader-modal v-if=\"isTranslationChange\" message=\"Translating content. Please wait...\" />\r\n\r\n                <div id=\"chat_widget_footer_menu\" class=\"w-100\">\r\n                  <div v-if=\"isScrollBottom\" class=\"scroll_bottom_indicator\"\r\n                    :class=\"{ animated_bottom: isScrollBottom }\"\r\n                    :style=\"{ color: themePrimaryColor, bottom: chatFooterHeight + 'px' }\" @click=\"scrollBottom()\">\r\n                    <em class=\"primaryicon-angle-down\" />\r\n                  </div>\r\n                  <transition name=\"slide-up\">\r\n                    <div v-show=\"textLengthValidation\" class=\"text_length_validation\">\r\n                      Text must be less than 256 characters.\r\n                    </div>\r\n                  </transition>\r\n                  <div class=\"chat__footer\" :class=\"{ 'opacity-0': isWorkingHoursEnable }\">\r\n                    <input id=\"MessageBox\" v-model=\"userInput\" type=\"text\" :disabled=\"disable ||\r\n                      disableChat ||\r\n                      isWaitingForResponse ||\r\n                      fullfillmenttextList.length === 0\r\n                      \" class=\"txtInput\" name=\"user__input\"\r\n                      :placeholder=\"disableText ? disableText : 'Type your message...'\" autocomplete=\"off\"\r\n                      maxlength=\"256\" @keyup.enter=\"sendMessage()\" @input=\"selectedAutoCompletedValue = {}\" />\r\n                    <button class=\"chat__footer__btn bgcolor-primary theme-bg-color\"\r\n                      :disabled=\"disable || disableChat || isWaitingForResponse\" @click=\"sendMessage()\">\r\n                      <i title=\"send\" class=\"primaryicon-longarrow-right\" />\r\n                    </button>\r\n                  </div>\r\n\r\n                  <div class=\"chat__footer__icon align-items-center\">\r\n                    <div class=\"text-center cursor-pointer flex-1 footer-menu pt-1 pb-1 py-lg-c-2\"\r\n                      @mouseover=\"isHoverMenu = true\" @mouseleave=\"isHoverMenu = false\" @click=\"\r\n                        startMainMenu($event);\r\n                      isWorkingHoursEnable = false;\r\n                      isTileNavigate = false;\r\n                      \">\r\n                      <menu-icon :is-hover-menu=\"isHoverMenu\" />\r\n\r\n                      <p class=\"m-0 ft-10\">Menu</p>\r\n                    </div>\r\n                    <div class=\"text-center cursor-pointer flex-1 footer-menu pt-1 pb-1 py-lg-c-2\"\r\n                      @mouseover=\"isHoverHour = true\" @mouseleave=\"isHoverHour = false\"\r\n                      @click=\"componentNavigate('Hours', $event)\">\r\n                      <hours-icon :is-hover-hour=\"isHoverHour\" />\r\n                      <p class=\"m-0 ft-10\">Hours</p>\r\n                    </div>\r\n\r\n                    <div v-if=\"enableTranslationIcon\"\r\n                      class=\"text-center cursor-pointer flex-1 footer-menu pt-1 pb-1 py-lg-c-2\"\r\n                      @mouseover=\"isHoverLanguage = true\" @mouseleave=\"isHoverLanguage = false\"\r\n                      @click=\"languageChangeEvent()\">\r\n                      <language-change-icon :icon-plus-text=\"true\">\r\n                        <template #iconPlusText=\"slotProps\">\r\n                          <language-icon :is-hover-language=\"isHoverLanguage\" />\r\n                          <p ref=\"languageRefContent\" class=\"m-0 ft-10\">{{ slotProps.text }}</p>\r\n                        </template>\r\n                      </language-change-icon>\r\n                    </div>\r\n\r\n                    <div v-if=\"!disableSignIn\" class=\"text-center cursor-pointer flex-1 footer-menu pt-1 pb-1 py-lg-c-2\"\r\n                      :class=\"{\r\n                        disableSignIn: isWaitingForResponse || fullfillmenttextList.length === 0,\r\n                      }\" @mouseover=\"isHoverUser = true\" @mouseleave=\"isHoverUser = false\" @click=\"LogoutUser($event)\">\r\n                      <sign-in-icon :is-hover-user=\"isHoverUser\" />\r\n                      <p class=\"m-0 ft-10\">\r\n                        {{ isAuthenticated === \"True\" ? \"Sign Out\" : \"Sign In\" }}\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div v-if=\"showTextData\" id=\"chatBodySec3\" class=\"chat__body__section2\">\r\n                <div id=\"chat__bodyview\" class=\"chat__subSec\" :style=\"{ height: chatWidgetBodySec3Height }\">\r\n                  <div class=\"text__conversation__block\">\r\n                    <textus-form ref=\"innerTextusForm\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <template v-if=\"!disableBackgroundBlur\">\r\n      <div @click=\"hideChatWidgetByOverlay()\" :style=\"slideWidgetHeight()\"\r\n        v-if=\"showwidget && !ismobile && !isHideOverly\" class=\"light-box-area\" />\r\n    </template>\r\n  </div>\r\n</template>\r\n<script src=\"./ChatWidget.js\"></script>\r\n<style scoped>\r\n.footer_disclaimer {\r\n  font-size: 9px;\r\n  opacity: 0.7;\r\n}\r\n\r\n#chat-widget {\r\n  color: #000;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.main-menu-icon {\r\n  display: grid;\r\n  grid-template-columns: auto auto auto;\r\n  gap: 1px;\r\n  max-width: 12px;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n}\r\n\r\n#chat-widget>>>ul.list-unstyled.service__types__list {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n#chat-widget>>>.service__types__list__item:last-child .service__chips__btn {\r\n  margin-bottom: 3px !important;\r\n}\r\n\r\n#chat-widget>>>.service_offers .service__chips__btn {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n#chat-widget>>>#chat__bodyview .df_message .primaryicon-right-arrow {\r\n  width: 16px;\r\n  height: 33px;\r\n  border-radius: 3px 0px 0px 3px;\r\n  margin: 0;\r\n  padding: 5px !important;\r\n  font-size: 10px;\r\n  z-index: 99;\r\n  right: 0 !important;\r\n  position: absolute;\r\n}\r\n\r\n#chat-widget>>>#chat__bodyview .df_message .primaryicon-left-arrow {\r\n  width: 16px;\r\n  height: 33px;\r\n  border-radius: 0px 3px 3px 0;\r\n  margin: 0;\r\n  padding: 5px;\r\n  font-size: 10px;\r\n  z-index: 99;\r\n  left: 0 !important;\r\n  position: absolute;\r\n}\r\n\r\n#chat-widget :deep(.v-slick-slider) {\r\n  position: inherit;\r\n}\r\n\r\n\r\n\r\n.chat__footer__icon span {\r\n  line-height: 0;\r\n}\r\n\r\nspan.primaryicon-ellipsis-vertical1 {\r\n  width: 4px;\r\n  height: 4px;\r\n  display: block;\r\n  background: #000;\r\n  border-radius: 50%;\r\n  box-sizing: border-box;\r\n  letter-spacing: 0;\r\n}\r\n\r\n.send-icon {\r\n  cursor: pointer;\r\n  font-size: 30px;\r\n  padding: 8px;\r\n  transform: rotate(44deg);\r\n  color: red;\r\n  margin-right: 10px;\r\n}\r\n\r\n#chat-footer {\r\n  border-top: 1px solid #ccc;\r\n}\r\n\r\n.waiting-message {\r\n  font-style: italic;\r\n}\r\n\r\n.chat-text-box {\r\n  box-shadow: 0 0 5pt 0.5pt #d3d3d3;\r\n}\r\n\r\n.chat-icon {\r\n  font-size: 25px;\r\n}\r\n\r\ntextarea:focus,\r\ninput:focus {\r\n  outline: none;\r\n}\r\n\r\n.df-button {\r\n  background-color: yellowgreen;\r\n}\r\n\r\nbody {\r\n  background: #eee;\r\n}\r\n\r\n.chat-list {\r\n  padding: 0;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.chat-list .chat-img {\r\n  float: left;\r\n  width: 48px;\r\n}\r\n\r\n.chat-list .chat-img img {\r\n  -webkit-border-radius: 50px;\r\n  -moz-border-radius: 50px;\r\n  border-radius: 50px;\r\n  width: 100%;\r\n}\r\n\r\n.chat-list .chat-message {\r\n  -webkit-border-radius: 50px;\r\n  -moz-border-radius: 50px;\r\n  border-radius: 50px;\r\n  background: #5a99ee;\r\n  display: inline-block;\r\n  padding: 10px 20px;\r\n  position: relative;\r\n}\r\n\r\n.chat-list .chat-message:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 15px;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.chat-list .chat-message h5 {\r\n  margin: 0 0 5px 0;\r\n  font-weight: 900;\r\n  line-height: 100%;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.chat-list .chat-message p {\r\n  line-height: 18px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.chat-list .chat-body {\r\n  margin-left: 20px;\r\n  float: left;\r\n  width: 70%;\r\n}\r\n\r\n.chat-list .in .chat-message:before {\r\n  left: -12px;\r\n  border-bottom: 20px solid transparent;\r\n  border-right: 20px solid #5a99ee;\r\n}\r\n\r\n.chat-list .out .chat-img {\r\n  float: right;\r\n}\r\n\r\n.chat-list .out .chat-body {\r\n  float: right;\r\n  margin-right: 20px;\r\n  text-align: right;\r\n}\r\n\r\n.chat-list .out .chat-message {\r\n  background: #fc6d4c;\r\n}\r\n\r\n.chat-list .out .chat-message:before {\r\n  right: -12px;\r\n  border-bottom: 20px solid transparent;\r\n  border-left: 20px solid #fc6d4c;\r\n}\r\n\r\n.card .card-header:first-child {\r\n  -webkit-border-radius: 0.3rem 0.3rem 0 0;\r\n  -moz-border-radius: 0.3rem 0.3rem 0 0;\r\n  border-radius: 0.3rem 0.3rem 0 0;\r\n}\r\n\r\n.card .card-header {\r\n  background: #17202b;\r\n  border: 0;\r\n  font-size: 1.2rem;\r\n  padding: 0.65rem 1rem;\r\n  position: relative;\r\n  font-weight: 900;\r\n  color: #ffffff;\r\n}\r\n\r\n.content {\r\n  margin-top: 40px;\r\n}\r\n\r\n.textwidget-close-icon {\r\n  display: block !important;\r\n  text-align: right;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.chat-image {\r\n  position: absolute;\r\n  width: 50px;\r\n  top: -30px;\r\n  right: 0px;\r\n}\r\n\r\n.nada-text-us-btn {\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 12px 14px;\r\n  letter-spacing: 2px;\r\n  display: block;\r\n  margin: 0px auto;\r\n  min-width: 100px;\r\n  background: #007cc3;\r\n}\r\n\r\n.nada-chat-con {\r\n  padding: 18px;\r\n  border-radius: 5px;\r\n  border: 1px none #000000;\r\n  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);\r\n  color: #555555;\r\n  z-index: 999999999;\r\n  width: 18%;\r\n  position: fixed;\r\n  bottom: 10px;\r\n  right: 5px;\r\n  min-width: 310px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.nada-child {\r\n  box-sizing: border-box;\r\n  margin: 12px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.chat-con {\r\n  position: fixed;\r\n  bottom: 40px;\r\n  z-index: 999;\r\n}\r\n\r\n.position-right-alignment {\r\n  right: 0px;\r\n}\r\n\r\n.position-left-alignment {\r\n  left: 0px;\r\n}\r\n\r\n.chat-con .circle-chat-con {\r\n  background: transparent;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  position: relative;\r\n}\r\n\r\n.chat-con .circle-chat-con img {\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.textwidgetbox {\r\n  position: fixed;\r\n  bottom: 0px;\r\n  width: 25%;\r\n  background: #fff;\r\n  padding: 20px;\r\n  padding-bottom: 0px;\r\n  z-index: 999999999;\r\n  box-shadow: 2px 2px 10px 3px #eeeeee;\r\n}\r\n\r\n.cls-3 {\r\n  fill: #fff;\r\n}\r\n\r\n@media (max-width: 800px) {\r\n  .textwidgetbox {\r\n    width: 70%;\r\n  }\r\n\r\n  .send-btn-con .text-send-btn {\r\n    margin: 5px 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .chat-con {\r\n    bottom: 25px;\r\n    z-index: 1100 !important;\r\n  }\r\n\r\n  .chat-con.position-right-alignment {\r\n    right: 4px;\r\n  }\r\n\r\n  .chat-con.position-left-alignment {\r\n    left: 4px;\r\n  }\r\n\r\n  .nada-text-us-btn {\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    color: #fff;\r\n    text-align: center;\r\n    padding: 14px;\r\n    letter-spacing: 2px;\r\n    display: block;\r\n    margin: 0px auto;\r\n    min-width: 150px;\r\n    z-index: 3;\r\n    width: 80%;\r\n    position: fixed;\r\n    bottom: 43px;\r\n    right: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .nada-chat-con {\r\n    width: 97%;\r\n    min-width: unset;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .textwidgetbox {\r\n    width: 80%;\r\n  }\r\n\r\n  .chat-textarea-con {\r\n    margin: 10px auto;\r\n  }\r\n\r\n  .textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left {\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1366px) {\r\n  .chat-con {\r\n    bottom: 89px;\r\n  }\r\n}\r\n\r\n#chat-widget .modal-content {\r\n  box-shadow: 4px 0px 10px 0px #eeeeee;\r\n  border-radius: 0;\r\n  border-left: 1px solid #eee !important;\r\n}\r\n\r\n.chat__content.position-right-alignment {\r\n  right: 0;\r\n}\r\n\r\n.chat__content.position-left-alignment {\r\n  left: 0;\r\n}\r\n\r\n.chat__header {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 5px 15px;\r\n  border-bottom: 1px solid #eee;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.095) !important;\r\n  height: 5vh;\r\n}\r\n\r\n.chat__header__btn {\r\n  padding: 0;\r\n  background: none;\r\n  border: 0;\r\n  outline: none;\r\n  box-shadow: none;\r\n  cursor: pointer;\r\n  width: 25px;\r\n}\r\n\r\n.header__icon {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #999;\r\n}\r\n\r\n.chat__header h5 {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.chat__body {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n.chat__body__section {\r\n  width: 100%;\r\n  height: 75vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n.chat__body__section2 {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  margin: 0 auto;\r\n}\r\n\r\n.chat__subSec {\r\n  width: 100%;\r\n  height: 65vh;\r\n  overflow: auto;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n#chatBodySec3 .chat__subSec {\r\n  height: 75vh;\r\n}\r\n\r\n.chat__body__section2 .headTxt5 {\r\n  font-size: 13px;\r\n  text-align: center;\r\n  margin: 10px auto 10px;\r\n  color: #000;\r\n}\r\n\r\n.chat__body__box {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: 1px solid #eee;\r\n  border-radius: 5px;\r\n  padding: 30px 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.chat__body__box:not(:last-child) {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.chat__body__btn {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border: 0;\r\n  margin-bottom: 5px;\r\n  background: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.icon__cont__box img {\r\n  height: 40px;\r\n  margin-right: 9px;\r\n}\r\n\r\n.icon__cont {\r\n  font-size: 12px;\r\n}\r\n\r\n#chatBodySec1 .chat__body__btn__title {\r\n  font-size: 20px !important;\r\n  font-weight: 900;\r\n}\r\n\r\n.chat__body__para {\r\n  font-size: 9px;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  color: #999;\r\n}\r\n\r\n.chat__footer {\r\n  width: 100%;\r\n  height: 5vh;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 0;\r\n  position: relative;\r\n  z-index: 9;\r\n}\r\n\r\n.txtInput {\r\n  width: 100%;\r\n  height: 5vh;\r\n  background: #f5f5f5;\r\n  border: 0;\r\n  border-radius: 0;\r\n  outline: none;\r\n  text-align: left;\r\n  padding: 5px 10px;\r\n  font-size: 16px;\r\n  color: #000;\r\n}\r\n\r\n.chat__footer__btn {\r\n  width: 2vw;\r\n  height: 5vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #fff;\r\n  border: 0;\r\n  border-radius: 0;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.chat__footer__icon {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  z-index: 9;\r\n}\r\n\r\n.chat__conversation__block {\r\n  width: 100%;\r\n}\r\n\r\n.chat__conversation__block div:nth-of-type(1) {\r\n  padding: 0;\r\n}\r\n\r\n.chat__conversation__block div:nth-of-type(1) div {\r\n  padding: 0;\r\n}\r\n\r\n.chat__conversation__block div:not(:first-child) {\r\n  padding: 0;\r\n}\r\n\r\n.chat__conversation__block div:not(:first-child)>div {\r\n  padding: 0;\r\n}\r\n\r\n.chips__btn {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  padding: 6px 12px;\r\n  min-width: 56px;\r\n  height: 32px;\r\n}\r\n\r\n#chat-widget .rounded-buttons.chips__btn {\r\n  font-size: 12px !important;\r\n  font-weight: 400 !important;\r\n  padding: 6px 12px !important;\r\n  min-width: 56px !important;\r\n  height: 32px !important;\r\n  text-transform: unset !important;\r\n}\r\n\r\n.chat_loader {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 24px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@-webkit-keyframes ball-pulse-sync {\r\n  20% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  40% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  60% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  80% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes ball-pulse-sync {\r\n  20% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  40% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  60% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  80% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(1) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.36s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.36s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(2) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.27s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.27s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(3) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.18s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.18s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(4) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.09s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.09s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(5) {\r\n  -webkit-animation: ball-pulse-sync 1s 0s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s 0s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div {\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 100%;\r\n  margin: 0px;\r\n  -webkit-animation-fill-mode: both;\r\n  animation-fill-mode: both;\r\n  display: inline-block;\r\n}\r\n\r\n@media all and (max-width: 576px) {\r\n  .chat__content {\r\n    width: 80%;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 12vw;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 577px) {\r\n  .chat__content {\r\n    width: 80%;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 12vw;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 768px) {\r\n  .chat__content {\r\n    width: 50%;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 8vw;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 992px) {\r\n  .chat__content {\r\n    width: 30%;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 4vw;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1200px) {\r\n  .chat__content {\r\n    width: 28%;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 3vw;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1400px) {\r\n  .chat__content {\r\n    width: 24%;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1900px) {\r\n  .footer_disclaimer {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .header__icon.primaryicon-times {\r\n    font-size: 11px !important;\r\n    color: #d9d9d9;\r\n  }\r\n\r\n  .header__icon.primaryicon-longarrow-left {\r\n    font-size: 14px !important;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .chat__body__box {\r\n    padding: 50px 30px;\r\n  }\r\n\r\n  .chat__subSec {\r\n    height: 65vh;\r\n  }\r\n\r\n  .chat__body__section {\r\n    height: 75vh;\r\n  }\r\n\r\n  #chatBodySec3 .chat__subSec {\r\n    height: 75vh;\r\n  }\r\n\r\n  .chat__footer {\r\n    height: 6vh;\r\n  }\r\n\r\n  .chat__footer__icon {\r\n    height: 6vh;\r\n  }\r\n\r\n  .chat__footer__icon svg {\r\n    height: 21px !important;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  .py-lg-c-2 {\r\n    padding: 0.5rem 0 !important;\r\n  }\r\n\r\n  .py-lg-c-2 .ft-10 {\r\n    font-size: 11px !important;\r\n  }\r\n\r\n  .txtInput {\r\n    height: 6vh;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 3vw;\r\n    height: 6vh;\r\n  }\r\n\r\n  .chat__footer__btn i {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .chat__header h5 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat__body__section2 .headTxt5 {\r\n    font-size: 19px;\r\n    font-weight: bold;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .chat__body__para {\r\n    font-size: 11px;\r\n  }\r\n\r\n  #chatBodySec1 .icon__cont {\r\n    font-size: 20px;\r\n  }\r\n\r\n  #chatBodySec1 .chat__body__para {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .header__icon {\r\n    font-size: 11px;\r\n  }\r\n\r\n  #chatBodySec1 .chat__body__btn__title {\r\n    font-size: 40px !important;\r\n    font-weight: 900;\r\n  }\r\n\r\n  .icon__cont__box img {\r\n    height: 50px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 2500px) {\r\n  .footer_disclaimer {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .chat__body__box {\r\n    padding: 70px 30px;\r\n    min-height: 320px;\r\n  }\r\n\r\n  .chat__footer {\r\n    height: 4vh;\r\n  }\r\n\r\n  .txtInput {\r\n    height: 4vh;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 3vw;\r\n    height: 4vh;\r\n  }\r\n\r\n  .chat__footer__btn i {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .chat__header h5 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .chat__body__section2 .headTxt5 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  #chatBodySec1 .icon__cont__box {\r\n    width: 48px;\r\n    height: 48px;\r\n    margin-right: 20px;\r\n  }\r\n\r\n  #chatBodySec1 .icon__cont {\r\n    font-size: 20px;\r\n  }\r\n\r\n  #chatBodySec1 .chat__body__para {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .header__icon {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 3800px) {\r\n  .footer_disclaimer {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .chat__body__box {\r\n    padding: 50px 30px;\r\n    min-height: 420px;\r\n  }\r\n\r\n  .chat__body__box:not(:last-child) {\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  .chat__content {\r\n    width: 22%;\r\n  }\r\n\r\n  .chat__header {\r\n    padding: 5px 20px;\r\n  }\r\n\r\n  #chatBodySec3 .chat__subSec {\r\n    height: 76vh;\r\n  }\r\n\r\n  .chat__footer {\r\n    height: 4vh;\r\n  }\r\n\r\n  .txtInput {\r\n    height: 4vh;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .chat__footer__btn {\r\n    width: 3vw;\r\n    height: 4vh;\r\n  }\r\n\r\n  .chat__footer__btn i {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .chat__header h5 {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .chat__body__section2 .headTxt5 {\r\n    font-size: 32px;\r\n    margin: 20px auto 30px;\r\n  }\r\n\r\n  .chat__body__para {\r\n    font-size: 32px;\r\n  }\r\n\r\n  #chatBodySec1 .icon__cont__box {\r\n    width: 82px;\r\n    height: 82px;\r\n    margin-right: 20px;\r\n  }\r\n\r\n  #chatBodySec1 .icon__cont {\r\n    font-size: 36px;\r\n  }\r\n\r\n  #chatBodySec1 .chat__body__para {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .header__icon {\r\n    font-size: 32px;\r\n  }\r\n}\r\n\r\n.text__conversation__block {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.text__conversation__block>>>.beforechannelsready {\r\n  width: 100%;\r\n  padding: 0 20px;\r\n}\r\n\r\n.text__conversation__block>>>.back-button {\r\n  visibility: hidden;\r\n}\r\n\r\n.text__conversation__block>>>.channel-list {\r\n  width: 100%;\r\n  padding: 0 20px;\r\n  margin: 0 0 20px 0;\r\n}\r\n\r\n.text__conversation__block>>>.channel-form {\r\n  width: 100%;\r\n  height: auto;\r\n  overflow: auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n.text__conversation__block>>>.input__contA {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n.text__conversation__block>>>.mobile-number-box .name-input {\r\n  border: 1px solid #eee;\r\n  border-radius: 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.text__conversation__block>>>.mobile-number-box .input__hold {\r\n  margin: 0 0 10px 0;\r\n}\r\n\r\n.text__conversation__block>>>.mobile-number-box .mobile-number {\r\n  color: #999;\r\n  margin: 5px 0;\r\n  font-size: 11px;\r\n}\r\n\r\n.text__conversation__block>>>.chat-textarea-con::before,\r\n.text__conversation__block>>>.chat-textarea-con::after {\r\n  display: none;\r\n}\r\n\r\n.text__conversation__block>>>.chat-textarea-con textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  border: 1px solid #eee;\r\n  border-radius: 5px;\r\n}\r\n\r\n.text__conversation__block>>>.sales-radio-con {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.text__conversation__block>>>.sales-radio-con>div {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.text__conversation__block>>>.sales-radio-con .custom-radio-btn .radio-text {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.text__conversation__block>>>.sales-radio-con .custom-radio-btn .radio-text .custom-radio-btn-input {\r\n  margin-right: 5px;\r\n}\r\n\r\n.text__conversation__block>>>.sales-radio-con .custom-radio-btn .radio-text .custom-radio-btn-label {\r\n  font-size: 10px;\r\n}\r\n\r\n.text__conversation__block>>>.note-info-text {\r\n  font-size: 13px;\r\n}\r\n\r\n.text__conversation__block>>>.chat-textarea-con {\r\n  width: 100%;\r\n  margin: 20px auto;\r\n  font-size: 12px;\r\n}\r\n\r\n.service__types>>>em.primaryicon-left-arrow.slick-arrow {\r\n  background: #007cc3 !important;\r\n}\r\n\r\n.service__types>>>em.primaryicon-right-arrow.slick-arrow {\r\n  background: #007cc3 !important;\r\n}\r\n\r\n.service__types>>>em.primaryicon-left-arrow.slick-disabled,\r\n.service__types>>>em.primaryicon-right-arrow.slick-disabled {\r\n  pointer-events: none;\r\n  opacity: 0;\r\n}\r\n\r\n.chat__footer__icon .footer-menu svg {\r\n  position: relative;\r\n  bottom: 0px;\r\n}\r\n\r\n.chat__footer__icon .footer-menu:hover {\r\n  cursor: pointer;\r\n  background: #f5f5f5;\r\n  transition: 0.5s;\r\n}\r\n\r\n.chat__footer__icon .footer-menu:hover svg {\r\n  bottom: -2px;\r\n  transition: 0.5s;\r\n}\r\n\r\n.chat__footer__icon img {\r\n  height: 12px;\r\n}\r\n\r\n.footer-menu svg {\r\n  height: 16px;\r\n  fill: #b3b3b3;\r\n}\r\n\r\n.header__icon.primaryicon-times {\r\n  font-size: 11px !important;\r\n  color: #d9d9d9;\r\n}\r\n\r\n.header__icon.primaryicon-longarrow-left {\r\n  color: #c7c7c7;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n\r\n.chat__subSec::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n.chat__subSec::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n}\r\n\r\n#chat-widget.textwidgetbox {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.chat__footer.opacity-0 {\r\n  opacity: 0;\r\n}\r\n\r\n.chat-con.position-right-alignment {\r\n  right: 10px;\r\n}\r\n\r\n.chat-con.position-left-alignment {\r\n  left: 10px;\r\n}\r\n\r\n.chat_widget_footer_menu #MessageBox:active {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.txtInput::placeholder {\r\n  color: #0000008c !important;\r\n}\r\n\r\n#chat-widget::v-deep .service__types__list__item .service__chips__btn {\r\n  font-weight: 400 !important;\r\n  padding: 6px 12px !important;\r\n  min-width: 56px;\r\n  text-transform: unset !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n#chat-widget::v-deep .chat__subSec .service__chips__btn {\r\n  font-weight: 400 !important;\r\n  padding: 6px 12px !important;\r\n  min-width: 56px;\r\n  text-transform: unset !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n#chat-widget::v-deep .service_offers .service__chips__btn {\r\n  margin-bottom: 0 !important;\r\n  font-weight: 400 !important;\r\n  padding: 6px 12px !important;\r\n  min-width: 56px;\r\n  text-transform: unset !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n#chat-widget::v-deep #Service_Types .service__chips__btn {\r\n  font-size: 9px !important;\r\n  font-weight: 400 !important;\r\n  padding: 2px !important;\r\n  min-width: 56px !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.header__icon.primaryicon-times:hover {\r\n  background: #f3f3f3;\r\n  transition: 0.5s ease-in-out;\r\n  transform: rotate(360deg);\r\n  display: block;\r\n  color: #000;\r\n  padding: 5px;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.header__icon.primaryicon-longarrow-left:hover {\r\n  background: #f3f3f3;\r\n  transition: 0.4s ease-in-out;\r\n  padding: 6px 8px;\r\n  color: #000;\r\n  font-size: 10px !important;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.disableSignIn {\r\n  pointer-events: none;\r\n  opacity: 0.8;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.text_length_validation {\r\n  text-align: center;\r\n  background: #eb9c5c;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  padding: 3px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.slide-up-enter-active,\r\n.slide-up-leave-active {\r\n  transition: transform 0.5s;\r\n  transform: translateY(0px);\r\n}\r\n\r\n.slide-up-enter,\r\n.slide-up-leave-to {\r\n  transform: translateY(30px);\r\n}\r\n\r\n#chat-widget.textwidgetbox.is_tablet_device {\r\n  width: 50% !important;\r\n}\r\n\r\n.scroll_bottom_indicator {\r\n  position: absolute;\r\n  right: 10px;\r\n  bottom: 18%;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 9px;\r\n  background: #fff;\r\n  border: 1px solid #d5cccc;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  z-index: 1;\r\n}\r\n\r\n@media (min-width: 1900px) {\r\n  .scroll_bottom_indicator {\r\n    width: 22px;\r\n    height: 22px;\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n.scroll_bottom_indicator:hover {\r\n  transition: 0.5s;\r\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\r\n}\r\n\r\n.scroll_bottom_indicator.animated_bottom {\r\n  display: flex;\r\n  animation: animated_bottom 2s;\r\n  transition: 0.5s;\r\n}\r\n\r\n@keyframes animated_bottom {\r\n  0% {\r\n    transform: translateY(60px);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n.light-box-area {\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  z-index: 99;\r\n}\r\n\r\n.signInNavigationModalLoader {\r\n  position: absolute;\r\n  background: rgba(240, 242, 250, 0.768627451);\r\n  height: 100%;\r\n  width: 100%;\r\n  z-index: 99;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.signInNavigationModalLoader .c_border_r {\r\n  border-radius: 11px;\r\n}\r\n\r\n.chat__footer__icon:has(.disableSignIn) {\r\n  cursor: not-allowed;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
